import { UpcomingOnSpecificTvChannelTray } from '../../../domain/upcoming-on-specific-tv-channel-tray';
import {
  ChannelSpecificUpcomingPageItemApiModel,
  CreateChannelSpecificUpcomingPageItemRequestApiModel,
  UpdateChannelSpecificUpcomingPageItemRequestApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  layoutMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  displayServiceTypeIconMapperApiToDomain,
  layoutMapperApiToDomain,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { UpcomingOnSpecificTvChannelTrayViewModel } from './upcoming-on-specific-tv-channel-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  layoutMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'UpcomingOnSpecificTvChannelTray'

/**
 * DOMAIN -> API
 */

export const mapUpcomingOnSpecificTvChannelTrayDomainModelToApiModel = (
  item: UpcomingOnSpecificTvChannelTray,
  pageVersionId?: string,
  tenantId?: string
): CreateChannelSpecificUpcomingPageItemRequestApiModel & UpdateChannelSpecificUpcomingPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    layoutMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    channelId: item.channel.id,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapUpcomingOnSpecificTVChannelTrayApiModelToDomainModel = (
  pageItem: ChannelSpecificUpcomingPageItemApiModel
): UpcomingOnSpecificTvChannelTray => {
  return remainderMapper(
    mapperPipe(
      pageItem,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperApiToDomain,
      layoutMapperApiToDomain
    ),
    () => ({
      type: 'UpcomingOnSpecificTvChannelTray',
      channel: {
        id: pageItem.channel.id,
        channelID: pageItem.channel.channelId,
        channelName: pageItem.channel.channelName,
        channelNumber: pageItem.channel.channelNumber,
      },
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapUpcomingOnSpecificTvChannelTrayDomainModelToViewModel = (
  pageItem: UpcomingOnSpecificTvChannelTray
): UpcomingOnSpecificTvChannelTrayViewModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.UpcomingOnSpecificTvChannelTray,
    channel: pageItem.channel,
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapUpcomingOnSpecificTvChannelTrayViewModelToDomainModel = (
  vm: UpcomingOnSpecificTvChannelTrayViewModel
): UpcomingOnSpecificTvChannelTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'UpcomingOnSpecificTvChannelTray', // AXB-83
    channel: vm.channel,
  }));
};
